import { rootClasses } from './formkit.theme'
import disableAutofillPlugin from './src/plugins/disableAutofillPlugin'
import { createAutoHeightTextareaPlugin } from '@/plugins/autoHeightTextArea'
import { createAutoAnimatePlugin } from '@formkit/addons'
import type { FormKitOptions } from '@formkit/core'
import { en, es, vi } from '@formkit/i18n'
import { genesisIcons, eye, eyeClosed } from '@formkit/icons'
import { createProPlugin, inputs } from '@formkit/pro'
import { defaultConfig } from '@formkit/vue'

const formKitPro = createProPlugin(import.meta.env.VITE_FORMKIT_PRO_KEY, inputs)

function getGlobalSettings() {
	return {
		locales: { en, es, vi },
		locale: 'en',
		config: {
			rootClasses,
		},
		plugins: [
			createAutoAnimatePlugin(),
			createAutoHeightTextareaPlugin(),
			formKitPro,
			disableAutofillPlugin,
		],
		icons: {
			...genesisIcons,
			eye,
			eyeClosed,
			// This icon below is for the custom green checkbox in session document flow
			StopIcon:
				'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M4.5 7.5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9Z" clip-rule="evenodd" /></svg>',
		},
	}
}

const config: FormKitOptions = defaultConfig(getGlobalSettings())

export default config

export function localizedConfig(locale: string): FormKitOptions {
	const globalConfig = getGlobalSettings()
	globalConfig.locale = locale

	return defaultConfig(globalConfig)
}
